import { ReactNode } from 'react';
import { Form } from 'react-bootstrap';

interface Props {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  unit: string;
  disabled?: boolean;
  zoneColor?: string;
  children?: ReactNode;
  secondary?: ReactNode;
  formatValue?: (value: number) => string;
}

export default function BaseSlider({ label, value, onChange, min, max, step, unit, disabled, zoneColor, children, secondary, formatValue }: Props) {
  const displayValue = formatValue ? formatValue(value) : value;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Form.Label className="text-light mb-0">{label}</Form.Label>
        <span className="text-light fw-bold" style={{ fontSize: '1.1rem' }}>
          {displayValue} {unit}
        </span>
      </div>
      <Form.Range
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        className="form-range-zone"
        style={{ '--zone-color': zoneColor || '#0d6efd' } as React.CSSProperties}
      />
      {secondary && <div className="text-secondary text-small mt-2">{secondary}</div>}
      {children}
    </div>
  );
}
